import axios from 'axios'
import AscentiaService from './ascentiaService'
// import Qs from 'qs'

const values = {
  workspaces: null,
  datasets: null,
  reports: null,
}

const getters = {
  workspaces() {
    let url = `/powerbi/workspaces`
    return axios.get(url)
  },
  datasets() {
    let url = `/powerbi/datasets`
    return axios.get(url)
  },
  reports() {
    let url = `/powerbi/reports`
    return axios.get(url)
  },
  validateReportName(dashboardparams) {
    let url = `/powerbi/validateReportName`
    const params = new URLSearchParams(dashboardparams)
    return axios.get(url, { params })
  },
  embedToken(reportId) {
    return axios.get(`/powerbi/embedToken?reportId=${reportId}`)
  },
}

const saves = {
  createReport(createReportRequest) {
    return axios.post(`/powerbi/Report`, createReportRequest)
  },
  updateReportPermissions(updateReportPermissionsRequest) {
    return axios.put(
      `/powerbi/reportPermissions`,

      updateReportPermissionsRequest,
    )
  },
  updateReport(updateReportRequest) {
    return axios.put(`/powerbi/Report`, updateReportRequest)
  },

  cloneReport(cloneReportRequest) {
    return axios.post(`/powerbi/Report`, cloneReportRequest)
  },
}
const deletes = {
  deleteReport(reportGuid) {
    return axios.delete(`/powerbi/Report?reportGuid=${reportGuid}`)
  },
}

export default class PowerBiService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
  get deletes() {
    return deletes
  }
}
